/* Component Dependencies */
var languageSelectorTemplate = require('templates/languageSelector.hbs');
var languageSelectorDropdownTemplate = require('templates/languageSelectorDropdown.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
	type: 'languageSelector',
	template: {
		'languageSelector': languageSelectorTemplate,
		'languageSelectorDropdown': languageSelectorDropdownTemplate
	},

	subscribe: {
		'TOGGLE_LANGUAGE_DROPDOWN': 'toggleDropdownDisplay',
  },
  
  bindEvents: function () {
    if(this.$el.hasClass("tile-language-dropdown")){
      $(document).on('click', _.bind(this.onDocumentClick, this));
      this.$el.on('click', _.bind(this.onDropdownClick, this));
      this.setSelectedDoamin();
    }
  },

	/**
	* This function is used to toggle the dropdown on clicking the language icon 
	* @param {Object} event Mouse event triggered on language dropdown click. 
	*/
	toggleDropdownDisplay: function (event) {
		this.$el.toggleClass("is-hidden");
  },
  
  /**
  * This function is used to close the dropdown when clicked outside. 
  * @param {Object} event Mouse event triggered on document click. 
  */
  onDocumentClick: function (event) {
    this.$el.addClass("is-hidden");
  },

  /**
  * This function is used to cancel the dropdown click event to stop it from closing. 
  * @param {Object} event Mouse event triggered on document click. 
  */
  onDropdownClick: function (event) {
		event.stopPropagation();
  },

  /**
  * This function is used to append hidden input having LANG_DOM value to be submitted with 
  * different internet connection forms. 
  * @param {none}
  */
  setSelectedDoamin: function () {
		var selectedDomain = this.$el.find('input[name="SELECTED_DOMAIN"]').val();
		if(selectedDomain){
      var internetConnectionForms = ['.js-form-sign-in','.js-form-connect-access-code','.js-form-add-device','.js-confirm-upgrade','.js-form-keep-service'];
      internetConnectionForms.forEach(function(formGroup) {
        $(formGroup).each(function (i, form) {
          $(form).append('<input type="hidden" name="LANG_DOM" value="'+selectedDomain+'"/>');
        });
      });
		}
	}
});
